import { httpCreate } from './http';

const http = httpCreate('/srv/marketing');

export const marketing = {
	getWhite(params) {
		return http.get('/white/get', { params, ttl: 1000 });
	},
};
